import axios from 'axios'
import config from './config'

// 30s ceiling so a hung backend never leaves a Vuex `loading` flag stuck on
// true. Most endpoints respond in <1s; if one needs longer, override per call.
const REQUEST_TIMEOUT_MS = 30000

const instance = axios.create({
  baseURL: config.baseUrl + '/api/',
  withCredentials: false,
  timeout: REQUEST_TIMEOUT_MS,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

export const bookingService = axios.create({
  baseURL: config.bookingServiceUrl,
  withCredentials: false,
  timeout: REQUEST_TIMEOUT_MS,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

export const setAuthToken = (token) => {
  instance.defaults.headers.Authorization = token
  bookingService.defaults.headers.Authorization = token
}

const googleMapsApi = axios.create({
  baseURL: config.googleMapsBaseUrl,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

// Always resolves with the shape `{ location, city }`; either field may be
// null when the geocoder returns no result or the request fails.
export const googleSearchLongAndLatOnMap = async (searchAddress) => {
  const empty = { location: null, city: null }
  try {
    const res = await googleMapsApi.get('json', {
      params: {
        address: searchAddress,
        key: config.googleMapsApiKey
      }
    })
    const firstResult = res?.data?.results?.[0]
    if (!firstResult?.geometry?.location) {
      return empty
    }
    const components = firstResult.address_components
    const city =
      components && components.length > 2 ? components[2].long_name : null
    return { location: firstResult.geometry.location, city }
  } catch (err) {
    console.warn('googleSearchLongAndLatOnMap failed', err)
    return empty
  }
}

export default instance
